module.exports = __webpack_public_path__ + "static/media/trademark-circle.1f94dc04.svg";